module.exports = __webpack_public_path__ + "static/media/cart.f7f6f243.svg";